

"use client"

import { usePathname } from "next/navigation"
import Link from "next/link"
import { menuItems } from "./AppSidebar"
import { Home } from "lucide-react"

function AppBreadCrumbs() {
    const pathname = usePathname()

    // 找到当前路径对应的菜单项
    const currentMenuItem = menuItems.find(item => item.href === pathname)

    return (
        <div className="breadcrumbs text-sm opacity-65">
            <ul>
                <li>
                    <Link href="/" className="flex items-center">
                        <Home size={16} className="mr-1" />
                        Home
                    </Link>
                </li>
                {currentMenuItem && (
                    <li>
                        <Link href={currentMenuItem.href} className="flex items-center">
                            {currentMenuItem.label}
                        </Link>
                    </li>
                )}
            </ul>
        </div>
    )
}

export default AppBreadCrumbs